import request from '@/router/axios'

export function login(username, password, __captchaVerification, rememberMe) {
  return request({
    url: "/api/login",
    method: "post",
    params: {
      username,
      password,
      __captchaVerification,
      rememberMe
    }
  })
}

export function getUserInfo() {
  return request({
    url: "/api/business/requirement/userinfo",
    method: "get"
  })
}

export function logout() {
  return request({
    url: "/api/logoutInPortal",
    method: "get"
  })
}

export function register(data) {
  return request({
    url: "/api/system/user/register",
    method: "post",
    data: data
  })
}

export function smsSend(mobile,__captchaVerification) {
  return request({
    url: "/api/business/sms/smsSend",
    method: "post",
    params: {
      mobile,
      __captchaVerification
    }
  })
}